import { useAppwideDrawerContext } from '../../../providers';
import { Box, HStack } from '../../Core';
import { Divider } from '../../Divider';
import { FormControlSizes, Toggle } from '../../Form';
import { Text } from '../../Text';

export function EntityAdminGuideToggle() {
  const { isGuideVisible, toggleGuide } = useAppwideDrawerContext();
  return (
    <HStack
      data-testid="entity-admin-show-guide-toggle"
      data-checked={isGuideVisible ? 'true' : 'false'}
      gap="spacing8"
      alignItems="center"
      cursor="pointer"
      onClick={toggleGuide}
    >
      <Text color="colors.gray.100" fontSize="fontSizeSm" whiteSpace="nowrap">
        Show Guide
      </Text>
      <Box
        onClick={event => {
          event.stopPropagation();
        }}
        display="flex"
      >
        <Toggle checked={isGuideVisible} onChange={toggleGuide} size={FormControlSizes.Small} />
      </Box>
    </HStack>
  );
}

export function EntityAdminGuideToggleWithDivider() {
  return (
    <HStack gap="spacing16" alignItems="center">
      <EntityAdminGuideToggle />
      <Divider orientation="vertical" />
    </HStack>
  );
}
